import { motion } from "framer-motion";
import { WHY_US } from "../../data/site";

export default function WhyLumotis() {
  return (
    <section
      id="why"
      className="py-20 md:py-28 bg-[#FAFAFA]"
      data-testid="why-section"
    >
      <div className="container">
        <div className="max-w-3xl mb-14">
          <p className="text-overline text-electric mb-3">02 — Why Lumotis</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold text-charcoal text-balance">
            Why 200+ Businesses Trust Lumotis for Digital Marketing
          </h2>
          <p className="mt-5 text-lg text-zinc-500 leading-relaxed">
            We're not a generic marketing agency. We're a growth partner that
            combines AI-first strategy, full-stack execution, and transparent
            reporting — built to turn your marketing budget into measurable
            revenue.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {WHY_US.map((w, idx) => {
            const Icon = w.icon;
            return (
              <motion.div
                key={w.title}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.06 }}
                className="group p-7 md:p-8 rounded-2xl bg-white border border-zinc-100 shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300"
                data-testid={`why-card-${idx}`}
              >
                <div className="w-11 h-11 grid place-items-center rounded-xl bg-electric/10 border border-electric/15 mb-5 group-hover:bg-electric group-hover:border-electric transition-colors">
                  <Icon className="w-5 h-5 text-electric group-hover:text-white transition-colors" strokeWidth={2} />
                </div>
                <h3 className="font-display text-xl font-semibold text-charcoal leading-tight">
                  {w.title}
                </h3>
                <p className="mt-3 text-[15px] text-zinc-500 leading-relaxed">
                  {w.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
